/**
 * LocalStorage adapter for web platform
 *
 * Implements storage interface using browser's localStorage
 */
export class LocalStorageAdapter {
  /**
   * Get value from localStorage
   * @param {string} key
   * @returns {Promise<string|null>}
   */
  async get(key) {
    try {
      return localStorage.getItem(key)
    } catch (error) {
      console.error(`[LocalStorageAdapter] Failed to get key "${key}":`, error)
      return null
    }
  }

  /**
   * Set value in localStorage
   * @param {string} key
   * @param {string} value
   * @returns {Promise<void>}
   */
  async set(key, value) {
    try {
      localStorage.setItem(key, value)
    } catch (error) {
      console.error(`[LocalStorageAdapter] Failed to set key "${key}":`, error)
      throw error
    }
  }

  /**
   * Remove value from localStorage
   * @param {string} key
   * @returns {Promise<void>}
   */
  async remove(key) {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error(`[LocalStorageAdapter] Failed to remove key "${key}":`, error)
    }
  }

  /**
   * Clear specified keys or all localStorage data
   * @param {string[]} [keys] - Optional array of keys to clear. If not provided, clears all.
   * @returns {Promise<void>}
   */
  async clear(keys) {
    try {
      if (keys && Array.isArray(keys)) {
        keys.forEach((key) => localStorage.removeItem(key))
      } else {
        localStorage.clear()
      }
    } catch (error) {
      console.error('[LocalStorageAdapter] Failed to clear storage:', error)
    }
  }
}
